module.exports = __webpack_public_path__ + "assets/rmg-fotoaufnahmen-einzelhandel-web-22.jpg";